export class ListInventoryAppsResponse {
    'apps';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryAppsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
